import React, { useState } from "react";
import {Link} from 'react-router-dom';
import { AppContext } from '../../AppContext';
import { useHistory } from "react-router-dom";
import { DateRevivier, Session, Animal } from '../../Types';
//import {MailIcon, NextIcon} from '../../components/Icons';

import './startscreen.scss';

const StartScreen: React.SFC<{}> = () => {

	let history = useHistory();
	const context = React.useContext(AppContext);
	let storedSessionsJson = localStorage.getItem("sessions");
	let sessionsFromStorage: Session[] = [];
	let revivedState = {};
	let activeSession = false;
	let animalCount = 0;
	const [herdName, setHerdName] = useState('')
	let lastHerd = '';

	if (storedSessionsJson) {
		
		// need to write reviver
		let temporaryObject = JSON.parse(storedSessionsJson, DateRevivier ) as Session[];
		if (!Array.isArray(temporaryObject)){
			sessionsFromStorage.push(temporaryObject);
		} else {
			sessionsFromStorage = temporaryObject;
		}
		
		sessionsFromStorage.sort( (a: Session ,b: Session ) => b.session_id - a.session_id);
		activeSession = (sessionsFromStorage[0].closed == null) ? true : false;
		
		// we don't need state handlers for these as they are static in this context
		animalCount = sessionsFromStorage[0].animals.length;
		lastHerd = sessionsFromStorage[0].herd;
		
		if(activeSession) {
			revivedState = {
				current: {
					date: new Date(),
					herd: lastHerd,
					tagNumber: 0,
					tailCondition: '',
					activeInjury: false,
					highSevereCount: 0,
					highMildCount: 0,
					midSevereCount: 0,
					midMildCount: 0,
					lowSevereCount: 0,
					lowMildCount: 0,
					dockedPosition: '',
				},
				previous: sessionsFromStorage[0].animals[0],
				session_id: sessionsFromStorage[0].session_id,
				herd: lastHerd,
				date: sessionsFromStorage[0].date,
				animals: sessionsFromStorage[0].animals,
			}			
		}
	}  


	const herdHandler = (event: React.ChangeEvent<HTMLInputElement>)  => {
		localStorage.setItem('activeHerd', JSON.stringify(event.target.value));
		setHerdName(event.target.value);
	};

	const startSessionHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
		event.preventDefault();
		// check if there is an open sessions
		if (activeSession) { 
			// open modal to confirm ending the previous sessions
			window.alert("There is already a session active.");
			return false;
		}

		// get the highest session id so we can increment
		let next_id = 1;
		if(sessionsFromStorage.length > 0) {
			next_id += sessionsFromStorage[0].session_id;
		}
		
		// create new sessions
		let newState = { 
			current: {
			  date: new Date(),
			  herd: '',
			  tagNumber: 0,
			  tailCondition: '',
			  activeInjury: false,
			  highSevereCount: 0,
			  highMildCount: 0,
			  midSevereCount: 0,
			  midMildCount: 0,
			  lowSevereCount: 0,
			  lowMildCount: 0,
			  dockedPosition: '',
			},
			previous: {
			  date: new Date(),
			  herd: '',
			  tagNumber: 0,
			  tailCondition: '',
			  activeInjury: false,
			  highSevereCount: 0,
			  highMildCount: 0,
			  midSevereCount: 0,
			  midMildCount: 0,
			  lowSevereCount: 0,
			  lowMildCount: 0,
			  dockedPosition: '',
			},
			session_id: 1,
			herd: '',
			date: new Date(),
			animals: [] as Animal[],
		  }



		
		newState.session_id = next_id;
		newState.herd = herdName;
		newState.current.herd = herdName;

		console.log(newState);
		
		context.setState(newState);

		// Persist our new session
		sessionsFromStorage.push(newState);
		localStorage.setItem('sessions', JSON.stringify(sessionsFromStorage));
		history.push('/enter_tag');
	}

	const continueSessionHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
		event.preventDefault();
		context.setState(revivedState as Session);
		history.push('/enter_tag');
	}

	const summaryHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
		event.preventDefault();
		history.push('/summary#' + sessionsFromStorage[0].session_id );
	}

	return (
		<>
			<nav className="navbar_startscreen">
				<span>TAIL SCORING APP</span>
			</nav>


			<h1>Enter Participant Code</h1>
			<div className="content-pane">
			{activeSession &&
				<div className="alert-panel mbm">
					<strong className="open-message">There is an open scoring session</strong>
					<button className="rpg_button continue-scoring-btn warning" onClick={continueSessionHandler} >
						<span>CONTINUE SCORING</span>
						<small>({animalCount} animals recorded)</small>
					</button>
					<button className="rpg_button finish-button warning" onClick={summaryHandler} >FINISH &amp; UPLOAD</button>
				</div>
			}
				<div className="enter-herd-form">
					
					<label className="rpg_form-control">
						<input type="text" placeholder="e.g. PTPT..." value={herdName} onChange={herdHandler} />
					</label>
					<button className="rpg_button action" onClick={startSessionHandler} >BEGIN SCORING</button>
				</div>
				<Link to="/previous_sessions" className="previous-link">VIEW PREVIOUS RECORDINGS</Link>
			</div>
		</>
	)
}

export default StartScreen;